import React from 'react'

export interface IconProps {
    width?: string | number;
    height?: string | number;
    className?: string;
}

export default function DeadLineReminderIcon({
    width = 150,
    height = 150,
    className = '',
}: IconProps) {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 300.000000 200.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)" stroke="none">
                <path fill="none" d="M0 1000 l0 -1000 1500 0 1500 0 0 1000 0 1000 -1500 0 -1500 0 0 -1000z m1515 620 c10 -11 20 -41 23 -68 4 -48 5 -49 48 -60 l44 -12 -16 -33 c-10 -17 -19 -64 -22 -103 -4 -61 -1 -80 20 -125 14 -30 37 -68 52 -86 36 -43 138 -93 190 -93 l41 0 0 -157 c0 -87 3 -170 7 -184 4 -14 41 -70 82 -124 61 -80 73 -102 65 -117 -9 -17 -34 -18 -591 -16 -525 3 -582 5 -591 19 -8 13 3 34 55 100 100 129 96 111 100 379 l3 235 36 76 c20 41 51 92 70 114 46 52 138 110 199 126 50 13 50 13 50 55 0 59 30 94 79 94 25 0 44 -7 56 -20z m460 -89 c77 -34 125 -114 125 -203 -1 -102 -62 -186 -158 -214 -70 -21 -128 -12 -189 29 -144 98 -123 322 37 391 48 21 136 20 185 -3z m-315 -1163 c-1 -38 -35 -101 -73 -135 -113 -99 -284 -42 -325 109 -6 20 -7 39 -4 42 3 3 95 6 204 6 l198 0 0 -22z" />
                <path fill="black" d="M1428 1599 c-13 -7 -18 -23 -18 -53 0 -51 -17 -69 -86 -93 -105 -35 -185 -106 -236 -211 l-33 -67 -5 -240 c-4 -155 -10 -250 -18 -268 -6 -15 -39 -63 -72 -105 -33 -43 -60 -81 -60 -85 0 -4 252 -7 560 -7 308 0 560 3 560 6 0 6 -47 67 -92 122 -56 66 -67 115 -68 304 l0 98 -27 6 c-74 16 -121 42 -173 94 -75 75 -105 152 -97 248 3 37 9 77 12 89 5 16 2 23 -17 28 -32 11 -47 34 -48 76 0 55 -40 83 -82 58z" />
                <path fill="red" d="M1793 1506 c-194 -91 -120 -383 94 -372 110 6 181 79 185 192 3 88 -41 154 -124 188 -52 22 -95 20 -155 -8z m125 -58 c8 -8 12 -50 12 -123 0 -112 -7 -135 -39 -135 -34 0 -51 31 -51 97 0 50 -5 70 -22 94 l-23 31 28 24 c30 26 75 32 95 12z" />
                <path fill="white" d="M1853 1428 c-13 -6 -23 -19 -23 -30 0 -21 11 -23 28 -6 9 9 12 -10 12 -85 0 -90 1 -97 20 -97 19 0 20 7 20 115 0 125 -3 129 -57 103z" />
                <path fill="black" d="M1294 333 c28 -73 87 -113 167 -113 60 0 99 19 133 63 50 65 46 67 -140 67 -154 0 -166 -1 -160 -17z" />
            </g>
        </svg>

    )
}